import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from '@Page_transform';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Header from './header';
import Banner from './banner';
import Content from './content';
import BottomFooter from './bottomFooter';
import Affix from './affix';
import { getCommentCount } from '@Container/common/client/services/api';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        allowComment: false,
        joinNum: 0,
        count: 0,
    };

    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        const {
            docData: { commentUrl },
        } = this.props.content;

        try {
            const { count, join_count, allow_comment } = await getCommentCount(commentUrl);

            this.setState({
                allowComment: allow_comment !== -1,
                joinNum: join_count,
                count,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { allowComment, joinNum, count } = this.state;
        const { content } = this.props;
        const {
            docData,
            docData: {
                logo,
                domain,
                breadCrumbdata,
                base62Id,
                title,
                pcUrl,
                url,
                newsTime,
                fhhAccountDetail,
                source,
                sourceUrl,
                summary,
                skey,
                commentUrl,
                imagesInContent,
            },
            search,
            banner,
            recommend,
            subject,
            recommendInfo,
            commentAd,
            asideAd,
            bottomAd,
            footer,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery: summary,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const headerData = {
            logo,
            search,
            domain,
        };
        const contentData = {
            captionData: {
                base62Id,
                fhhAccountDetail,
                title,
                pcUrl,
                url,
                newsTime,
                source,
                sourceUrl,
                skey,
                commentUrl,
                allowComment,
                joinNum,
                count,
                breadCrumbdata,
            },
            leftContentData: {
                article: docData,
                shareInfo,
                recommendInfo,
                commentAd,
            },
            rightContentData: {
                recommend,
                subject,
                asideAd,
            },
        };
        const footerData = { bottomAd, footer };

        return (
            <div>
                <Header content={headerData} />
                <Chip id="200158" type="struct" title="顶部banner" groupName="头部" content={banner}>
                    <Banner />
                </Chip>
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <NoSSR>
                    <Affix content={shareInfo} />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
